import React from "react";
import { Box, Typography } from "@mui/material";
import AnimatedOrb from "../AnimatedOrb";
import SpeechBubble from "../SpeechBubble";
import GradientButton from "../../../input/GradientButton";

const INTRO_SLIDES = [
  {
    message:
      "I'm Ori, your Focus Guide. I'm here to help you pick the tasks that make sense for today.",
  },
  {
    message:
      "I'm going to ask you a few questions so I can suggest some tasks that match your mindset.",
  },
];

/**
 * Intro step shown only the first time a user opens the Focus Guide.
 * Two slides introducing Ori the orb and what the guide does.
 */
const IntroStep = ({ slideIndex, onNext }) => {
  const slide = INTRO_SLIDES[slideIndex] || INTRO_SLIDES[0];
  const isLastSlide = slideIndex >= INTRO_SLIDES.length - 1;

  return (
    <Box className="task-guide-step task-guide-step--intro">
      <AnimatedOrb size="large" intensity="idle" />
      <SpeechBubble>
        <Typography variant="body1" sx={{ margin: 0, textAlign: "center" }}>
          {slide.message}
        </Typography>
      </SpeechBubble>

      <Box sx={{ marginTop: "24px" }}>
        <GradientButton
          text={isLastSlide ? "Get started" : "Next"}
          onClick={onNext}
        />
      </Box>
    </Box>
  );
};

export { INTRO_SLIDES };
export default IntroStep;
